export default {
    POST_BACK: 'POST_BACK',
    WEB: 'WEB',
    CALL: 'CALL',
    STATUS: 'status',
    GMT: 'GMT',
    CHAT_ENDED: 'CHAT_ENDED',
    CHAT_ENDED_WITH_TRANSCRIPT: 'CHAT_ENDED_WITH_TRANSCRIPT',
    SESSION_HAS_EXPIRED: 'SESSION_HAS_EXPIRED',
    CHAT_RESTART: 'CHAT_RESTART',
    IDLE_USER: 'IDLE_USER',
    BACK: 'BACK',
    RESTART: 'RESTART',
    SKIP: 'SKIP',
    SELECT: 'SELECT',
    SELECT_FILE: 'SELECT_FILE',
    DROP_AREA_TEXT_CW: 'DROP_AREA_TEXT_CW',
    DRAG_DROP_TEXT: 'DRAG_DROP_TEXT',
    DISMISS_CB_ON_CROSS: 'dismissCalloutBubbleOnCross',
    USER_LAST_MESSAGE_STATUS: 'USER_LAST_MESSAGE_STATUS',
    INCORRECT_INPUT_VALUE: 'INCORRECT_INPUT_VALUE',
    REQUIRED_FIELD: 'REQUIRED_FIELD',
    INVALID_VALIDATION: 'INVALID_VALIDATION',
    QUICK_MENU: 'QUICK_MENU',
    END_CHAT:'END_CHAT',
    SOUND: 'SOUND',
    INPUT_PLACEHOLDER: 'INPUT_PLACEHOLDER',
    REJECTED: 'REJECTED',
    AGENT: 'AGENT',
    BOT: 'BOT',
    DEFAULT_COLOR: '#4D34E9',
    SESSION_BOT_STATUS : 'isNetWindowMaximized',
    SESSION_BOT_UPDATED : 'SESSION_BOT_UPDATED',
    NETOMI_LOADER : 'net-loader',
    VISITOR: 'Visitor',
    ZENDESK: 'ZENDESK',
    SALESFORCE: 'SALESFORCE',
    GENERIC_AGENTDESK: 'GENERIC_AGENTDESK',
    PROACTIVE_GREETING_LABEL: 'PROACTIVE_GREETING',
    HTTPS: 'https:',
    LOCALHOST: 'localhost',
    EVENT_LEARN_ATTRIBUTE: 'event://;LEARN_ATTRIBUTE_EVENT;',
    SWITCH_INTENT_EVENT: 'event://;SWITCH_INTENT;;TARGET_NODE::',
    MEDIA_UPLOADED: 'event://;LEARN_ATTRIBUTE_EVENT;ATTACHMENT::value=Media has been uploaded',
    KEY_PREFIX: 'net_',
    DISABLED: 'disabled',
    HIDDEN: 'hidden',
    DEPARTMENT: 'department',
    END_CHAT_GREETING_DELAY: 1000,
    AWS_IOT: 'AWS_IOT',
    CALLOUT_BUBBLE_TEXT: 'CALLOUT_BUBBLE_TEXT',
    NETOMI_BOT: 'Netomi Bot',
    NETOMI: 'NETOMI',
    NETOMI_WEB_WIDGET: 'NETOMI_WEB_WIDGET',
    DEFAUlT_IDLE_TIMEOUT: '1800000',
    DEVICE_TABLET_REGEX: /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i,
    DEVICE_MOBILE_REGEX: '/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/',
    CONNECTION_STATUS_LABEL: 'connectionStatus',
    PUBLISH_EVENT_TO_IOT: 'publishEventToIoT',
    OFFLINE_BANNER_TEXT: 'OFFLINE_BANNER_TEXT',
    OFFLINE_MESSAGE_ERROR: 'OFFLINE_MESSAGE_ERROR',
    SENT: 'SENT',
    FAILED: 'FAILED',
    ASTERISK: '*',
    WEBHOOK_HISTORY: 'WEBHOOK_HISTORY',
    TYPING_INDICATOR_TIMEOUT: 'TYPING_INDICATOR_TIMEOUT',
    DEFAULT_MIN_TIME_FOR_TYPING_INDICATOR: 1500,
    DEFAULT_MAX_TIME_FOR_TYPING_INDICATOR: 5000,
    CSAT_RATE_LIMIT: 2,
    CSAT_RATE_LIMIT_STATE: 'CSATRateLimit',
    INFO: 'INFO',
    CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
    LANGUAGE: 'LANGUAGE',
    CURRENT_LOCALE: 'current_locale',
    END_CHAT_DISCLAIMER: 'END_CHAT_DISCLAIMER',
    EMAIL_ADDRESS_LABEL: 'EMAIL_ADDRESS_LABEL',
    ENTER_EMAIL_ID: 'ENTER_EMAIL_ID',
    WAS_THIS_HELPFUL: 'WAS_THIS_HELPFUL',
    SCREEN_READER_THUMBS_UP: 'SCREEN_READER_THUMBS_UP',
    SCREEN_READER_THUMBS_DOWN: 'SCREEN_READER_THUMBS_DOWN',
    END_CHAT_CONFIRM_BUTTON_CTA: 'END_CHAT_CONFIRM_BUTTON_CTA',
    END_CHAT_CANCEL_BUTTON_CTA: 'END_CHAT_CANCEL_BUTTON_CTA',
    // Blank screen causes
    EMPTY_HISTORY_CALL: 'Empty history call',
    EMPTY_PROACTIVE_RESPONSE: 'Empty proactive greetings response',
    EMPTY_CALLOUT_RESPONSE: 'Empty callout greetings response',
    DEFAULT_LOGO_IMAGE: 'https://chatwidget-plugin-dev1.s3.us-east-1.amazonaws.com/dev1/images/defaultLogo.png',
    DEFAULT_BOT_IMAGE: 'https://chatwidget-plugin-dev1.s3.us-east-1.amazonaws.com/dev1/images/defaultBotImage.png',
    BRAND_GPT: 'Brand GPT',
    ACTIONABLE : 'Actionable',
    ARTICLES_OFFERS: 'Articles & Offers',
    UNREAD_MESSAGES_STATE:'unreadMessagesState',
    MASKED: 'MASKED',
    UNMASKED: 'UNMASKED',
    KNOWLEDGE_AI_INPUT_BOX_PLACEHOLDER: 'Ask a question...',
    FORM_FIELDS_SPECIAL_CHARS: [';', '&', '^$^', '=', '::', '_'],
    DEFAULT_OUTPUT_KEY_INPUT_value: 'DEFAULT_OUTPUT_KEY_INPUT::value',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    COMPLETED: 'completed',
    DOWNLOAD: 'DOWNLOAD',
    DOWNLOADING: 'DOWNLOADING',
    DOWNLOADED: 'DOWNLOADED',
    PILL_SEPERATOR: '---',
    BACK_TO_BOT_SYSTEM_EVENT: 'BACK_TO_BOT_SYSTEM_EVENT',
    RESTART_CHAT_LABEL: 'Chat Restarted',
    CHAT_RATED_GOOD: 'Chat rated Good',
    CHAT_RATED_BAD: 'Chat rated Bad',
    CHAT_RATING_REMOVED: 'Chat rating removed',
    SURVEY_SUBMITTED: 'Survey Submitted',
    STREAM_TIME_FOR_EACH_CHUNK: 150, // delay for each chunk in animation and streaming
    LIMIT_REACHED: 'Limit reached',
    RESTART_CHAT_PLACEMENT_MENU: 'context_menu',
    RESTART_CHAT_PLACEMENT_INPUT_FIELD: 'input_field',
    RESTART_PRIMARY_BTN_TEXT: 'RESTART_PRIMARY_BTN_TEXT',
    RESTART_DISCLAIMER_TEXT: 'If you perform this action, the conversation will be wiped up and start over',
    TEXT: 'text',
    TRY_AGAIN: 'Please try again.',
    FILE_NAME_UUID: 'fileNameUUID',
    MANDATORY: 'MANDATORY',
    GENERATED_BY_USER: 'USER',
    GENERATED_BY_SYSTEM: 'SYSTEM',
    MAIL_VALIDATION_MESSAGE: 'MAIL_VALIDATION_MESSAGE',
    SETTINGS_LABEL: 'SETTINGS_LABEL',
    MAXIMIZE_LABEL: 'MAXIMIZE_LABEL',
    RESTORE_LABEL: 'RESTORE_LABEL',
    HEADER_CLOSE_LABEL: 'HEADER_CLOSE_LABEL',
    MINIMIZE_LABEL: 'MINIMIZE_LABEL',
    TRANSCRIPT_LABEL: 'TRANSCRIPT_LABEL',
    PRIMAR_COLOR_PTI: '#5177FF',
    SECONDARY_COLOR_PTI: '#D2E2FF',
    TERMS_AND_CONDITION_ACCEPTED_MESSAGE : {
        CHAT_WIDGET: (timestamp) => {
            return `You accepted the Terms of Service on ${timestamp}.`
        },
        TRANSCRIPT: () => {
            return `User accepted Terms of Service`
        }
    }
}
